import React from 'react'
import "./Edit_User_Modal_Frame.css"

function Edit_User_Modal_Frame() {
  return (
    <>
        <section className='Edit_User_Modal_Frame'>
        <div className="table-frame-holder">
          <img
            className="table-frame-img"
            src={process.env.PUBLIC_URL + "/Frame/table-frame.png"}
            alt="table-frame-img"
          />
        </div>
        </section>
    </>
  )
}

export default Edit_User_Modal_Frame